import { css } from 'styled-components';

const PAGE_STYLES = css`
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  margin-top: 5px;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;

  .header {
    min-height: 60px;
    margin-bottom: 10px;
    text-align: center;
  }

  .content {
    flex: 2;
    overflow: auto;
    margin-bottom: 10px;
  }

  > .footer {
    min-height: 40px;
  }
`;

export default PAGE_STYLES;
